import { Box } from '@chakra-ui/react';
import React from 'react';

export const LoadingDots: React.FC = () => {
  const dotAnimation = {
    '@keyframes dotPulse': {
      '0%, 100%': {
        opacity: 0.3,
      },
      '50%': {
        opacity: 1,
      },
    },
  };

  const dotStyle = {
    w: '8px',
    h: '8px',
    bg: 'gray.900',
    rounded: 'full',
    display: 'inline-block',
  };

  return (
    <Box display="flex" gap={2} justifyContent="center" alignItems="center">
      <Box
        {...dotStyle}
        css={{
          ...dotAnimation,
          animation: 'dotPulse 1.4s ease-in-out infinite',
        }}
      />
      <Box
        {...dotStyle}
        css={{
          ...dotAnimation,
          animation: 'dotPulse 1.4s ease-in-out 0.2s infinite',
        }}
      />
      <Box
        {...dotStyle}
        css={{
          ...dotAnimation,
          animation: 'dotPulse 1.4s ease-in-out 0.4s infinite',
        }}
      />
    </Box>
  );
};
